import { css } from '@emotion/react';

export const CrossIcon = css`
  --color: #7fe200;
  display: inline-block;
  width: 24px;
  height: 24px;
  background: linear-gradient(var(--color) 0 0), linear-gradient(var(--color) 0 0);
  background-position: center;
  background-size: 50% 2px, 2px 50%;
  background-repeat: no-repeat;
`;
